/**
 * Checks if a string ends with another
 * @param haystack String to search within
 * @param needle String to search for
 * @returns whether the search term was found
 */
export function endsWith(haystack: string, needle: string): boolean {
  return haystack.substring(haystack.length - needle.length, haystack.length) === needle
}
